import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Map, Marker, Polygon, TileLayer, ZoomControl} from "react-leaflet";
import {IMapas, INewParcelaSection, INotificacion} from "../../../types";
import {LatLngTuple} from "leaflet";
import {readFileAsync} from "../../../tools/readFile";
import {Typography, Button, TextField, Paper} from "@material-ui/core";
import {NavigateBefore, Delete} from "@material-ui/icons";
import Basura from "../../../icons/PNGs/basura.png";
import Agregar from "../../../icons/PNGs/agregar.png";
import Editar from "../../../icons/PNGs/editar.png";
import FixedPoint from "../../../icons/PNGs/fixed_point.png";
import SelectedPoint from "../../../icons/PNGs/selected_point.png";
import CreatePoint from "../../../icons/PNGs/create_point.png";
import EditablePoint from "../../../icons/PNGs/editable_point.png";
import DeletePoint from "../../../icons/PNGs/delete_point.png"
import BlackPoint from "../../../icons/PNGs/black_point.png"
import SimplePoint from "../../../icons/PNGs/simple_point.png"
import L from "leaflet";
import InfoFinal from "./InfoFinal";
import AyudaSector from "./AyudaSector";

const pointInPolygon = require('point-in-polygon');
const texts = require('../../../texts/crearparcela.json');


const fixed_icon = new L.Icon({
    iconUrl: FixedPoint,
    iconRetinaUrl: FixedPoint,
    iconSize: [25, 25]
})

const selected_icon = new L.Icon({
    iconUrl: SelectedPoint,
    iconRetinaUrl: SelectedPoint,
    iconSize: [25, 25]
})

const create_icon = new L.Icon({
    iconUrl: CreatePoint,
    iconRetinaUrl: CreatePoint,
    iconSize: [25, 25]
})

const editable_icon = new L.Icon({
    iconUrl: EditablePoint,
    iconRetinaUrl: EditablePoint,
    iconSize: [25, 25]
})

const delete_icon = new L.Icon({
    iconUrl: DeletePoint,
    iconRetinaUrl: DeletePoint,
    iconSize: [25, 25]
})

const black_icon = new L.Icon({
    iconUrl: BlackPoint,
    iconRetinaUrl: BlackPoint,
    iconSize: [25, 25]
})

const simple_icon = new L.Icon({
    iconUrl: SimplePoint,
    iconRetinaUrl: SimplePoint,
    iconSize: [10, 10]
})

const colors = {
    "fixed": "#448eff",
    "select": "#80ED99",
    "create": "#ffffff",
    "edit": "#dcc32d",
    "delete": "#bf3636"
}

const caracteres_validos = 'qwertyuiopasdfghjklñzxcvbnmQWERTYUIOPASDFGHJKLÑZXCVBNM1234567890_-.'

interface IProps {
    mapa: IMapas
    zoom: number
    center: LatLngTuple
    polygon: LatLngTuple[]
    sectores: Record<string, LatLngTuple[]>
    idioma: string
    notify(notification: INotificacion): void
    setMapa(mapa: IMapas): void
    setZoom(zoom: number): void
    setCenter(center: LatLngTuple): void
    setSectores(sectores: Record<string, LatLngTuple[]>): void
    setEditando(editando: boolean): void
    setCrearParcelaSection(seccion: INewParcelaSection): void
}

interface IState {
    hover: string
    clicked: string
    nuevo_nombre: string
    selected: string
    refresh_sectors: boolean
    cargado: boolean
    selected_poit: number[]
    block_point: string
    text: Record<string, string>
}

const urls = {
    satelite: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    carreteras: 'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}'
}

class Sectores extends React.Component<IProps, IState> {
    state: IState = {
        hover: '',
        clicked: '',
        nuevo_nombre: '',
        selected: '',
        refresh_sectors: false,
        cargado: true,
        selected_poit: [],
        block_point: '',
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    componentDidMount() {
        let sectores = {} as Record<string, LatLngTuple[]>
        for (let sector of Object.keys(this.props.sectores)) {
            let borrar = false
            for (let point of this.props.sectores[sector]) {
                if (!pointInPolygon(point, this.props.polygon)) {
                    if (!this.props.polygon.includes(point)) borrar = true
                }
            }
            if (!borrar) sectores[sector] = this.props.sectores[sector]
        }
        this.props.setSectores(sectores)
    }

    handleVista = () => {
        if (this.props.mapa === 'satelite') this.props.setMapa('carreteras')
        if (this.props.mapa === 'carreteras') this.props.setMapa('satelite')
        return
    }

    handleEdited = (e: any) => {
        try {
            const sectores: Record<string, LatLngTuple[]> = {}
            let cnt = 0
            for (const id of Object.keys(e.sourceTarget._layers)) {
                if (!e.sourceTarget._layers[id].hasOwnProperty('_latlngs')) continue
                const polygon: LatLngTuple[] = []
                for (const element of e.sourceTarget._layers[id].getLatLngs()[0]) {
                    polygon.push([element.lat, element.lng])
                }
                polygon.push(polygon[0])
                if (polygon.length === this.props.polygon.length) {
                    let pasar = true
                    for (let i = 0; i < polygon.length; i++) {
                        if (polygon[i][0] !== this.props.polygon[i][0]) pasar = false
                        if (polygon[i][1] !== this.props.polygon[i][1]) pasar = false
                    }
                    if (pasar) continue
                }
                sectores[cnt.toString()] = polygon
                cnt += 1
            }
            this.props.setSectores(sectores)
            this.props.setEditando(false)
        } catch (e) {
            this.props.setEditando(false)
            return
        }
    }

    onDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    }

    onDrop = async (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (this.state.selected.length !== 0) {
            try{
                const files = e!.dataTransfer.files;
                if (files.length > 1) {
                    this.props.notify({message: this.state.text["24"], variant: 'warning'})
                    return
                }
                const file = files[0]
                if (!file.name.toLowerCase().endsWith('.kml')) {
                    this.props.notify({message: this.state.text["25"], variant: 'warning'})
                    return
                }

                const resultData = await readFileAsync(file, true);
                const kml = new DOMParser().parseFromString(resultData as string, "text/xml");
                const c = kml.getElementsByTagName('coordinates')

                const sectores = this.props.sectores
                let inPolygon = true
                for (let i = 0; i < c.length; i++) {
                    const text = c[i].textContent as string
                    const polygon: LatLngTuple[] = []
                    for (const row of text.split(" ")) {
                        const lat = parseFloat(row.split(',')[1])
                        const lng = parseFloat(row.split(',')[0])
                        polygon.push([lat, lng])
                        if (!pointInPolygon([lat, lng], this.props.polygon)) inPolygon = false
                    }

                    if (polygon.length < 4 ||
                        polygon[0][0] !== polygon[polygon.length-1][0] ||
                        polygon[0][1] !== polygon[polygon.length-1][1]) {
                        this.props.notify({message: this.state.text["26"], variant: 'error'})
                        return
                    }

                    if (inPolygon) {
                        sectores[this.state.selected] = polygon
                    } else {
                        this.props.notify({message: this.state.text["43"], variant: 'warning'})
                    }
                }
                this.setState({cargado: false})
                this.props.setSectores(sectores)
                setTimeout(() => {this.setState({cargado: true})}, 100)
            } catch (e) {
                this.props.notify({message: e as string, variant: 'error'})
            }
        } else {
            this.props.notify({message: this.state.text["44"], variant: 'warning'})
        }
    }

    setIcon = (sector: string) => {
        if (this.state.selected !== sector) return fixed_icon
        switch (this.state.clicked) {
            case "crear":
                return create_icon
            case "editar":
                return editable_icon
            case "borrar":
                return delete_icon
            default:
                return selected_icon
        }
    }

    setColor = (sector: string) => {
        if (this.state.selected !== sector) return colors["fixed"]
        switch (this.state.clicked) {
            case "crear":
                return colors["create"]
            case "editar":
                return colors["edit"]
            case "borrar":
                return colors["delete"]
            default:
                return colors["select"]
        }
    }

    complete = (): boolean => {
        let preparado = true
        if (Object.keys(this.props.sectores).length === 0) {
            preparado = false
        } else {
            for (let sector of Object.keys(this.props.sectores)) {
                if (this.props.sectores[sector].length < 3) preparado = false
            }
        }
        return preparado
    }


    handleClick = () => {
        this.props.setCrearParcelaSection('InfoFinal')
    }


    render () {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '100%',
                }}
            >
                <InfoFinal/>
                <AyudaSector/>
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: '25%',
                        height: '100%',
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            width: '85%',
                            marginTop: 40,
                            marginBottom: 20,
                            justifyContent: "center"

                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 38,
                                fontWeight: "bold",
                                color: "#4C494B",
                                fontFamily: "Poppins",
                                textAlign: "center"
                            }}
                        >
                            {this.state.text["45"]}
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            height: '60%',
                            width: '80%',
                            alignItems: "center"
                        }}
                    >

                        <Button
                            color={"secondary"}
                            variant={"contained"}
                            style={{
                                width: "95%",
                                height: "fit-content",
                                marginBottom: 20,
                                textTransform: "none"
                            }}
                            onClick={() => this.props.setCrearParcelaSection('AyudaSector')}
                        >
                            <Typography
                                style={{
                                    color: "#4C494B",
                                    fontFamily: "Poppins",
                                    fontSize: 18,
                                    fontWeight: "bold",
                                }}
                            >
                                {this.state.text["78"]}
                            </Typography>
                        </Button>

                        {/*<Button*/}
                        {/*    color={"primary"}*/}
                        {/*    variant={"contained"}*/}
                        {/*    disabled={Object.keys(this.props.sectores).length > 0}*/}
                        {/*    style={{*/}
                        {/*        width: "95%",*/}
                        {/*        height: "fit-content",*/}
                        {/*        marginBottom: 20,*/}
                        {/*        textTransform: "none"*/}
                        {/*    }}*/}
                        {/*    onClick={() => {*/}
                        {/*        let sectores = {"sector": this.props.polygon} as Record<string, LatLngTuple[]>*/}
                        {/*        this.props.setSectores(sectores)*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    <Typography*/}
                        {/*        style={{*/}
                        {/*            color: "#4C494B",*/}
                        {/*            fontFamily: "Poppins",*/}
                        {/*            fontSize: 18,*/}
                        {/*            fontWeight: "bold",*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        {this.state.text["109"]}*/}
                        {/*    </Typography>*/}
                        {/*</Button>*/}

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <div/>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: '30%'
                                }}
                            >
                                <Typography
                                    style={{
                                        fontSize:20,
                                        fontWeight: this.state.clicked === "crear"? "bold" : "normal",
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        textAlign: "center",
                                        height: 30
                                    }}
                                >
                                    {this.state.text["28"]}
                                </Typography>
                                <Button
                                    variant={"contained"}
                                    style={{
                                        width: window.innerWidth*0.25*0.8*0.3,
                                        height: window.innerWidth*0.25*0.8*0.3,
                                        borderRadius: 20,
                                        backgroundColor: this.state.clicked === "crear"? "#eee" : "white",
                                    }}
                                    onClick={() => {
                                        if (this.state.selected.length === 0) {
                                            this.props.notify({message: 'Selecciona un sector o añade uno si aún no tienes', variant: "warning"})
                                        } else {
                                            if (this.state.clicked === "crear") {
                                                this.setState({clicked: ""})
                                            } else {
                                                this.setState({clicked: "crear"})
                                            }
                                        }
                                    }}
                                >
                                    <img
                                        style={{
                                            width: window.innerWidth*0.25*0.8*0.3,
                                            height: window.innerWidth*0.25*0.8*0.3
                                        }}
                                        src={Agregar}

                                        alt="agregar img"
                                    />
                                </Button>

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: '30%'
                                }}
                            >
                                <Typography
                                    style={{
                                        fontSize:20,
                                        fontWeight: this.state.clicked === "editar"? "bold" : "normal",
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        textAlign: "center",
                                        height: 30
                                    }}
                                >
                                    {this.state.text["29"]}
                                </Typography>
                                <Button
                                    variant={"contained"}
                                    style={{
                                        borderRadius: 20,
                                        backgroundColor: this.state.clicked === "editar"? "#eee" : "white",
                                        width: window.innerWidth*0.25*0.8*0.3,
                                        height: window.innerWidth*0.25*0.8*0.3
                                    }}
                                    onClick={() => {
                                        if (this.state.selected.length === 0) {
                                            this.props.notify({message: 'Selecciona un sector o añade uno si aún no tienes', variant: "warning"})
                                        } else {
                                            if (this.state.clicked === "editar") {
                                                this.setState({clicked: ""})
                                            } else {
                                                this.setState({clicked: "editar"})
                                            }
                                        }
                                    }}
                                >
                                    <img
                                        style={{
                                            width: window.innerWidth*0.25*0.8*0.3,
                                            height: window.innerWidth*0.25*0.8*0.3
                                        }}
                                        src={Editar}

                                        alt="editar img"
                                    />
                                </Button>

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: '30%'
                                }}
                            >
                                <Typography
                                    style={{
                                        fontSize:20,
                                        fontWeight: this.state.clicked === "borrar"? "bold" : "normal",
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        textAlign: "center",
                                        height: 30
                                    }}
                                >
                                    {this.state.text["30"]}
                                </Typography>
                                <Button
                                    variant={"contained"}
                                    style={{
                                        borderRadius: 20,
                                        backgroundColor: this.state.clicked === "borrar"? "#eee" : "white",
                                        width: window.innerWidth*0.25*0.8*0.3,
                                        height: window.innerWidth*0.25*0.8*0.3
                                    }}
                                    onClick={() => {
                                        if (this.state.selected.length === 0) {
                                            this.props.notify({message: this.state.text["46"], variant: "warning"})
                                        } else {
                                            if (this.state.clicked === "borrar") {
                                                this.setState({clicked: ""})
                                            } else {
                                                this.setState({clicked: "borrar"})
                                            }
                                        }
                                    }}
                                >
                                    <img
                                        style={{
                                            width: window.innerWidth*0.25*0.8*0.3,
                                            height: window.innerWidth*0.25*0.8*0.3
                                        }}
                                        src={Basura}

                                        alt="borar img"
                                    />
                                </Button>
                            </div>
                            <div/>

                        </div>


                        <Button
                            color={"primary"}
                            variant={"contained"}
                            disabled={Object.keys(this.props.sectores).length > 0}
                            style={{
                                width: "95%",
                                height: "fit-content",
                                // marginBottom: 20,
                                textTransform: "none",
                                marginTop: 20
                            }}
                            onClick={() => {
                                let sectores = {"sector": this.props.polygon} as Record<string, LatLngTuple[]>
                                this.props.setSectores(sectores)
                            }}
                        >
                            <Typography
                                style={{
                                    color: "#4C494B",
                                    fontFamily: "Poppins",
                                    fontSize: 18,
                                    fontWeight: "bold",
                                }}
                            >
                                {this.state.text["109"]}
                            </Typography>
                        </Button>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                margin: 10,
                                width: '95%'
                            }}
                        >
                            <TextField
                                style={{
                                    width: '60%',
                                    fontFamily: "Poppins"
                                }}
                                inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                value={this.state.nuevo_nombre}
                                onChange={e => {
                                    let text = ''
                                    for (let letter of e.target.value) {
                                        if (caracteres_validos.includes(letter)) text += letter
                                    }
                                    this.setState({nuevo_nombre: text})
                                }}
                                label={this.state.text["47"]}
                            />
                            <Button
                                color={"primary"}
                                variant={"contained"}
                                disabled={this.state.nuevo_nombre.length === 0}
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    borderRadius: 10,
                                    width: '30%',
                                    marginBottom: -5
                                }}
                                onClick={() => {
                                    let disponible = true
                                    for (let name of Object.keys(this.props.sectores)) {
                                        if (name === this.state.nuevo_nombre) disponible = false
                                    }

                                    if (disponible) {
                                        this.setState({refresh_sectors: true})
                                        let sectores = this.props.sectores
                                        sectores[this.state.nuevo_nombre] = [] as LatLngTuple[]
                                        this.props.setSectores(sectores)
                                        setTimeout(() => {this.setState({refresh_sectors: false})}, 1)
                                        setTimeout(() => {this.setState({selected: this.state.nuevo_nombre})}, 100)
                                        setTimeout(() => {this.setState({nuevo_nombre: ''})}, 200)
                                    } else {
                                        this.props.notify({message: this.state.text["48"]+' '+this.state.nuevo_nombre, variant: "warning"})
                                    }
                                }}
                            >
                                <Typography
                                    style={{
                                        fontSize:18,
                                        fontWeight: "bold",
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        textTransform: 'none'
                                    }}
                                >
                                    {this.state.text["49"]}
                                </Typography>
                            </Button>

                        </div>

                        {!this.state.refresh_sectors &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflow: "auto",
                                    height: '100%',
                                    width: '100%',
                                    alignItems: "center",
                                }}
                            >
                                {Object.keys(this.props.sectores).map(name =>
                                    <div
                                        key={name}
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            width: '95%',
                                            height: 30,
                                            borderRadius: 15,
                                            marginTop: 10
                                        }}
                                    >
                                        <Paper
                                            elevation={this.state.hover === name ? 5 : 2}
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: window.innerWidth * 0.25 * 0.8 * 0.95 - 40,
                                                height: 30,
                                                borderTopLeftRadius: 10,
                                                borderBottomLeftRadius: 10,
                                                backgroundColor: this.state.selected === name? "#eee" : "white",
                                                cursor: "pointer",
                                            }}
                                            onMouseEnter={() => this.setState({hover: name})}
                                            onMouseLeave={() => this.setState({hover: ''})}
                                            onClick={() => {
                                                this.setState({selected: name})
                                            }}
                                        >
                                            <Typography
                                                style={{
                                                    fontSize: 18,
                                                    color: "#4C494B",
                                                    fontFamily: "Poppins"
                                                }}
                                            >
                                                {name}
                                            </Typography>
                                        </Paper>
                                        <Paper
                                            elevation={this.state.hover === 'del' + name ? 5 : 2}
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 40,
                                                height: 30,
                                                borderTopRightRadius: 10,
                                                borderBottomRightRadius: 10,
                                                cursor: "pointer",
                                                backgroundColor: this.state.selected === name? "#eee" : "white"
                                            }}
                                            onMouseEnter={() => this.setState({hover: 'del' + name})}
                                            onMouseLeave={() => this.setState({hover: ''})}
                                            onClick={() => {
                                                this.setState({refresh_sectors: true})
                                                let sectores = {} as Record<string, LatLngTuple[]>
                                                for (let sector of Object.keys(this.props.sectores)) {
                                                    if (sector !== name) {
                                                        sectores[sector] = this.props.sectores[sector]
                                                    }
                                                }
                                                this.props.setSectores(sectores)
                                                setTimeout(() => {this.setState({refresh_sectors: false, selected: ''})}, 1)

                                            }}
                                        >
                                            <Delete
                                                style={{
                                                    color: "#bf3636",
                                                    height: 25,
                                                    width: 25
                                                }}
                                            />
                                        </Paper>
                                    </div>
                                )}
                                <div style={{marginTop: 20}}/>
                            </div>
                        }

                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "80%",
                            height: '10%',
                        }}
                    >
                        {this.state.selected.length !== 0 &&
                        <Typography
                            style={{
                                fontSize: 20,
                                color: "#4C494B",
                                fontFamily: "Poppins",
                                textAlign: "center"
                            }}
                        >
                            {this.state.text["34"]}
                        </Typography>
                        }
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            height: '15%',
                            width: '80%',
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >
                        <Button
                            style={{
                                height: "fit-content",
                                borderRadius: 10
                            }}
                            onClick={() => this.props.setCrearParcelaSection("Ubicación")}
                        >
                            <NavigateBefore
                                style={{
                                    height: 30,
                                    width: 30
                                }}
                            />
                            <Typography
                                style={{
                                    textTransform: "none",
                                    fontSize: 20,
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    textDecoration: 'underline',
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["35"]}
                            </Typography>
                        </Button>

                        <Button
                            style={{
                                height: "fit-content",
                                borderRadius: 10
                            }}
                            variant={"contained"}
                            color={"primary"}
                            disabled={!this.complete()}
                            onClick={() => this.handleClick()}
                        >
                            <Typography
                                style={{
                                    textTransform: "none",
                                    fontSize: 20,
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["36"]}
                            </Typography>
                        </Button>

                    </div>

                </div>


                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '75%',
                        height: '100%',
                    }}
                    onDragOver={(e) => this.onDragOver(e)}
                    onDrop={(e) => this.onDrop(e)}
                >
                    <Map
                        center={this.props.center}
                        zoom={this.props.zoom}
                        zoomControl={false}
                        maxZoom={20}
                        style={{
                            width: '100%',
                            height: '100%',
                            zIndex: 1
                        }}
                        onmoveend={(e) => {
                            this.props.setZoom(e.target.getZoom())
                            this.props.setCenter([e.target.getCenter().lat,e.target.getCenter().lng])
                        }}
                    >
                        <ZoomControl
                            position={'topright'}
                        />
                        {this.props.mapa === 'satelite' && <TileLayer url={urls.satelite}/>}
                        {this.props.mapa === 'carreteras' && <TileLayer url={urls.carreteras}/>}

                        {this.state.cargado && Object.keys(this.props.sectores).map((sector, i) =>
                            this.props.sectores[sector].map((point: LatLngTuple, index) =>
                                <Marker
                                    key={point.toString()}
                                    draggable={this.state.clicked === "editar" && this.state.selected === sector}
                                    position={point}
                                    icon={this.setIcon(sector)}
                                    zIndexOffset={this.state.selected === sector?
                                        this.state.block_point !== i.toString()+index.toString()? 1000 : 1
                                        :
                                        100
                                    }
                                    onmouseover={() => {
                                        if (this.state.block_point !== i.toString()+index.toString()) {
                                            this.setState({selected_poit: point})
                                        }
                                    }}
                                    onmouseout={() => this.setState({selected_poit: []})}
                                    ondragstart={() => this.setState({block_point: i.toString()+index.toString(), selected_poit: []})}
                                    ondragend={e => {
                                        this.setState({cargado: false})
                                        this.setState({block_point: ""})
                                        if (pointInPolygon([e.target.getLatLng().lat, e.target.getLatLng().lng], this.props.polygon) || this.state.selected_poit.length > 0) {
                                            let poligon = this.props.sectores[this.state.selected] as LatLngTuple[]
                                            if (this.state.selected_poit.length) {
                                                poligon[index] = this.state.selected_poit as LatLngTuple
                                            } else {
                                                poligon[index] = [e.target.getLatLng().lat, e.target.getLatLng().lng] as LatLngTuple
                                            }
                                            let sectores = this.props.sectores
                                            sectores[this.state.selected] = poligon
                                            this.props.setSectores(sectores)
                                        }
                                        setTimeout(() => this.setState({cargado: true}), 1)
                                    }}
                                    onclick={(e) => {
                                        if (this.state.selected.length !== 0 && this.state.clicked === "crear") {
                                            this.setState({cargado: false})
                                            let sectores = this.props.sectores
                                            sectores[this.state.selected].push(this.state.selected_poit as LatLngTuple)
                                            this.props.setSectores(sectores)
                                            setTimeout(() => this.setState({cargado: true}), 1)
                                        }
                                    }}
                                />

                            )
                        )}

                        {this.props.polygon.map((point: LatLngTuple, index) =>
                            <Marker
                                key={point.toString()+index.toString()}
                                draggable={false}
                                position={point}
                                icon={black_icon}
                                zIndexOffset={10}
                                onmouseover={() => this.setState({selected_poit: point})}
                                onmouseout={() => this.setState({selected_poit: []})}
                                onclick={(e) => {
                                    if (this.state.selected.length !== 0 && this.state.clicked === "crear") {
                                        this.setState({cargado: false})
                                        let sectores = this.props.sectores
                                        sectores[this.state.selected].push(this.state.selected_poit as LatLngTuple)
                                        this.props.setSectores(sectores)
                                        setTimeout(() => this.setState({cargado: true}), 1)
                                    }
                                }}
                            />
                        )}


                        <Polygon
                            positions={this.props.polygon}
                            color={'rgba(0,0,0)'}
                            fillColor={'rgb(0,0,0)'}
                            onclick={(e) => {
                                if (this.state.selected.length !== 0 && this.state.clicked === "crear") {
                                    this.setState({cargado: false})
                                    let sectores = this.props.sectores
                                    sectores[this.state.selected].push([e.latlng.lat, e.latlng.lng] as LatLngTuple)
                                    this.props.setSectores(sectores)
                                    setTimeout(() => this.setState({cargado: true}), 1)
                                }
                            }}
                        />

                        {this.state.cargado &&
                        Object.keys(this.props.sectores).map(sector =>
                            <Polygon
                                key={'sector_'+sector}
                                positions={this.props.sectores[sector]}
                                color={this.setColor(sector) as string}
                                fillColor={this.setColor(sector) as string}
                                fillOpacity={0.2}
                                onclick={(e) => {
                                    if (this.state.clicked === "borrar" && this.state.selected === sector) {
                                        this.setState({cargado: false})
                                        let sectores = this.props.sectores
                                        sectores[this.state.selected] = [] as LatLngTuple[]
                                        this.props.setSectores(sectores)
                                        this.setState({clicked: ""})
                                        setTimeout(() => this.setState({cargado: true}), 1)
                                    }
                                    if (this.state.selected.length !== 0 && this.state.clicked === "crear") {
                                        this.setState({cargado: false})
                                        let sectores = this.props.sectores
                                        sectores[this.state.selected].push([e.latlng.lat, e.latlng.lng] as LatLngTuple)
                                        this.props.setSectores(sectores)
                                        setTimeout(() => this.setState({cargado: true}), 1)
                                    }
                                }}
                            />
                        )
                        }

                    </Map>

                    <div
                        style={{
                            width: 150,
                            height: 150,
                            marginRight: 20,
                            marginLeft: -174,
                            marginBottom: 20,
                            backgroundColor: "transparent",
                            zIndex: 2,
                            borderRadius: 20,
                            borderStyle: "solid",
                            borderWidth:2,
                            borderColor: this.state.hover === 'sat'? 'rgba(0,0,0,0.8)' : 'rgba(0,0,0,0.2)',
                            alignSelf: "flex-end"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 150,
                                height:150,
                                borderRadius: 20,
                                backgroundColor: this.state.hover === 'sat'? 'rgba(240,240,240)' :
                                    this.props.mapa === 'satelite'? 'rgba(128,128,128)' : "white",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            onMouseEnter={() => this.setState({hover: 'sat'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {this.handleVista()}}
                        >
                            <Map
                                center={this.props.center}
                                zoom={Math.floor(this.props.zoom/2)}
                                zoomControl={false}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: 20,
                                    cursor: "pointer"
                                }}
                            >
                                {this.props.mapa === 'carreteras' && <TileLayer url={urls.satelite}/>}
                                {this.props.mapa === 'satelite' && <TileLayer url={urls.carreteras}/>}
                            </Map>

                        </div>
                    </div>

                </div>

            </div>
        )
    }
}


const mapStateToProps = (state: IStore) => ({
    mapa: state.principal.mapa,
    zoom: state.principal.zoom,
    center: state.principal.center,
    polygon: state.crearParcela.polygon,
    sectores: state.crearParcela.sectores,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setMapa: (mapa: IMapas) => dispatch({type: "set-principal-mapa", mapa}),
    setZoom: (zoom: number) => dispatch({type: "set-principal-zoom", zoom}),
    setCenter: (center: LatLngTuple) => dispatch({type: "set-principal-center", center}),
    setSectores: (sectores: Record<string, LatLngTuple[]>) => dispatch({type: "set-crear-parcela-sectores", sectores}),
    setEditando: (editando: boolean) => dispatch({type: "set-crear-parcela-editando", editando}),
    setCrearParcelaSection: (seccion: INewParcelaSection) => dispatch({type: "select-crear-parcela-seccion", seccion})
});

export default connect(mapStateToProps, mapDispatchToProps)(Sectores);
